

const Tab = (props) => {
           return (
                      <div className="flex flex-row justify-center">
                                 <div className="flex flex-row justify-center">
                                            <span
                                                       className="w-[70px] h-[70px] rounded-[50px] bg-[#E44236] mx-4 cursor-pointer"
                                                       onClick={() => props.renderColor('red')}
                                            ></span>
                                            <span
                                                       className="w-[70px] h-[70px] rounded-[50px] bg-[#2ecc72] mx-4 cursor-pointer"
                                                       onClick={() => props.renderColor('green')}
                                            ></span>
                                            <span
                                                       className="w-[70px] h-[70px] rounded-[50px] bg-[#EEC213] mx-4 cursor-pointer"
                                                       onClick={() => props.renderColor('Yellow')}
                                            ></span>
                                            <span
                                                       className="w-[70px] h-[70px] rounded-[50px] bg-[#3498DB] mx-4 cursor-pointer"
                                                       onClick={() => props.renderColor('Fancy')}
                                            ></span>
                                            <span
                                                       className="w-[70px] h-[70px] rounded-[50px] bg-[#F5BCBA] mx-4 cursor-pointer"
                                                       onClick={() => props.renderColor('Blue')}
                                            ></span>
                                            <span
                                                       className="w-[70px] h-[70px] rounded-[50px] bg-[#B38AFF] mx-4 cursor-pointer"
                                                       onClick={() => props.renderColor('Primary')}
                                            ></span>
                                            <span
                                                       className="w-[70px] h-[70px] rounded-[50px] bg-[#1E293B] mx-4 cursor-pointer"
                                                       onClick={() => props.renderColor('Functional')}
                                            ></span>
                                            <span
                                                       className="w-[70px] h-[70px] rounded-[50px] bg-[#AD7C00] mx-4 cursor-pointer"
                                                       onClick={() => props.renderColor('Neutral')}
                                            ></span>
                                 </div>
                      </div>
           )

}
export default Tab